import LivedigitalSDKError from './LivedigitalSDKError';

class ForbiddenError extends LivedigitalSDKError {
  static readonly DEFAULT_MESSAGE = 'Forbidden';

  constructor(msg?: string, errorCode?: string, meta?: Record<string, unknown>) {
    super(msg ?? ForbiddenError.DEFAULT_MESSAGE, errorCode ?? 'forbidden', meta);
  }
}

export default ForbiddenError;
